import { useCallback } from 'react';
import { useLocalStorage } from 'services/hooks';
import { ModelView, ModelViewsSelectorProps } from './ModelViewsSelector.props';
import { MainContainer, ViewButtonContainer, ViewsContainer } from './ModelViewsSelector.styles';
import ViewButtonWithTooltip from './ViewButtonWithTooltip';

const MODELS_VIEWS_KEY = 'saved-model-views';

const ModelViewsSelector = ({ onLoadView, currentViewId, views: externalViews }: ModelViewsSelectorProps) => {
  const [internalViews] = useLocalStorage<ModelView[]>(MODELS_VIEWS_KEY, []);
  const views = externalViews ?? internalViews;

  const handleLoadView = useCallback((event: React.MouseEvent<HTMLButtonElement>, savedView: ModelView) => {
    event.stopPropagation();
    onLoadView(savedView);
  }, [onLoadView]);

  return (
    <MainContainer sx={{ ml: 1 }}>
      <ViewsContainer>
        {views.map(savedView => (
          <ViewButtonContainer key={savedView.id}>
            <ViewButtonWithTooltip 
              savedView={savedView} 
              currentViewId={currentViewId}
              onClick={handleLoadView}
            />
          </ViewButtonContainer>
        ))}
      </ViewsContainer>
    </MainContainer>
  );
};

export default ModelViewsSelector;